export const tag_list_ko = ["1940년대" ,
"1950년대" ,
"1960년대" ,
"1970년대" ,
"1980년대" ,
"1990년대" ,
"3D" ,
"가을" ,
"가을" ,
"가을/겨울" ,
"가을/겨울" ,
"간격" ,
"갈색" ,
"강렬한" ,
"개" ,
"개구리" ,
"거리 미술" ,
"거울" ,
"건축" ,
"검정" ,
"겨울" ,
"고딕" ,
"고래" ,
"고양이" ,
"곤충" ,
"과일" ,
"과자" ,
"구름" ,
"귀여운" ,
"그래피티" ,
"그래픽 꽃" ,
"그래픽 패턴" ,
"그래픽" ,
"그런지" ,
"그린" ,
"금" ,
"기린" ,
"기모노" ,
"깃털" ,
"깅엄 체크" ,
"꽃" ,
"꽃다발" ,
"꽃잎" ,
"나무" ,
"나뭇잎" ,
"나뭇잎" ,
"나방" ,
"나비" ,
"낙서" ,
"낙서하다" ,
"난초" ,
"남색" ,
"네온" ,
"노란색" ,
"녹색" ,
"니트" ,
"다이아몬드" ,
"단색화" ,
"단순한" ,
"대규모" ,
"대나무" ,
"대리석" ,
"대양" ,
"대칭" ,
"데이지" ,
"돌고래" ,
"동양의" ,
"두개골" ,
"디지털" ,
"딱정벌레" ,
"딸기" ,
"라벤더" ,
"라일락" ,
"레몬" ,
"레이스" ,
"레이어" ,
"레트로" ,
"로맨틱" ,
"리조트" ,
"마젠타" ,
"만다라" ,
"만화" ,
"만화경" ,
"말" ,
"멀티 컬러" ,
"멕시칸" ,
"모더니즘" ,
"모란" ,
"모로코" ,
"모양" ,
"모자이크" ,
"모티프" ,
"목련" ,
"목초지" ,
"무지개색" ,
"무채색" ,
"물" ,
"미래" ,
"미술" ,
"민속학의" ,
"바나나" ,
"바로크" ,
"바우 하우스" ,
"바틱염색" ,
"반다나" ,
"발렌타인" ,
"밝은" ,
"백합" ,
"뱀" ,
"번창한" ,
"번호" ,
"벡터 패턴" ,
"벽지" ,
"별" ,
"보라색" ,
"보석" ,
"보트" ,
"봄" ,
"봄/여름" ,
"북유럽의" ,
"분홍색" ,
"불가사리" ,
"붓꽃" ,
"붓터치" ,
"블로썸" ,
"빈티지" ,
"빛" ,
"빨간색" ,
"사각형" ,
"사과" ,
"사람들" ,
"사람들" ,
"사이키델릭한" ,
"사진" ,
"사탕" ,
"산호색" ,
"삼각형" ,
"삽화" ,
"새" ,
"색조의" ,
"생선" ,
"선" ,
"선박의" ,
"선인장" ,
"섬세한" ,
"셰브런" ,
"소규모" ,
"소용돌이" ,
"손바닥" ,
"손으로 그린" ,
"쇠사슬" ,
"수선화" ,
"수채화" ,
"순진한" ,
"숲" ,
"스카프" ,
"스케치" ,
"스텐실" ,
"시든" ,
"시보리" ,
"식물" ,
"식물" ,
"실루엣" ,
"아르누보" ,
"아이스크림" ,
"아즈텍" ,
"아프리카의" ,
"앵무새" ,
"야생화" ,
"양귀비" ,
"양치식물" ,
"어두운" ,
"얼룩말" ,
"여름 축제" ,
"여름" ,
"여자" ,
"엮다" ,
"예쁜" ,
"예술 & 공예" ,
"예술적" ,
"옴브레" ,
"옵티컬" ,
"왜곡된" ,
"용감한" ,
"우주" ,
"원" ,
"윤곽" ,
"은" ,
"은하" ,
"음료수" ,
"음식" ,
"이국적인" ,
"이카트" ,
"인디고" ,
"인디언" ,
"인상파" ,
"일본의" ,
"잉크" ,
"자동차" ,
"자수" ,
"자카드" ,
"잔꽃무늬" ,
"장난기" ,
"장미" ,
"장미" ,
"장식용" ,
"장식적인" ,
"재미있는" ,
"점" ,
"점" ,
"정글" ,
"제비꽃" ,
"주황색" ,
"중국풍의" ,
"지그재그",
"진한 블루" ,
"짙은 녹색" ,
"채소" ,
"청록색" ,
"청록색" ,
"체리" ,
"최소의" ,
"추상적인 꽃" ,
"코끼리" ,
"콜라주" ,
"크리스마스" ,
"크림색" ,
"큰 꽃" ,
"타이다이" ,
"타탄" ,
"터키석" ,
"토끼" ,
"튤립" ,
"파도" ,
"파란색 & 흰색" ,
"파스텔" ,
"파인애플" ,
"패치워크" ,
"팬지" ,
"펑크" ,
"페이즐리" ,
"편지" ,
"포장지" ,
"표범무늬" ,
"푸른" ,
"풀라드" ,
"풍경" ,
"플라밍고" ,
"픽셀" ,
"하얀색" ,
"하와이안" ,
"하운드투스" ,
"하트" ,
"한 여름" ,
"할로윈" ,
"핫핑크색" ,
"헤링본" ,
"현대의" ,
"현대의" ,
"호랑이" ,
"혼합 미디어" ,
"화려한" ,
"회색" ,
"휴가" ,
"흐릿한" ,
"히비스커스" ]